export default __webpack_public_path__ + "static/media/new-15.cf0ad9fc.png";